<span *ngIf="src == null && text != null" class="avatar-text">{{text}}</span>
<span *ngIf="src != null" class="avatar-img">
  <img [src]="src" alt="avatar" />
</span>
